import React from 'react'

function SearchImageItemTemplate() {
  return (
    <div>SearchImageItemTemplate</div>
  )
}

export default SearchImageItemTemplate